import React, { useState } from 'react';
import stargazing_photo from './images/stargazing.jpg';
import AstronomyNightSky from './AstronomyNightSky';

// Dates/times sourced from seasky.org's astronomy calendar; times converted from UTC to IST (UTC+5:30),
// so date/time reflect the IST calendar day the event actually falls on for viewers in India.
const astronomyEvents = [
  { date: "2026-01-03", time: "3:34 PM IST", emoji: "🌕", name: "Wolf Moon", note: "full moon — supermoon" },
  { date: "2026-01-04", emoji: "🌠", name: "Quadrantids", note: "meteor shower peak (night of Jan 3–4)" },
  { date: "2026-01-10", emoji: "🪐", name: "Jupiter at Opposition", note: "closest & brightest for the year" },
  { date: "2026-02-02", time: "1:41 AM IST", emoji: "🌕", name: "Snow Moon", note: "full moon" },
  { date: "2026-02-17", emoji: "🌑", name: "Annular Solar Eclipse", note: "" },
  { date: "2026-02-19", emoji: "✨", name: "Mercury Greatest Eastern Elongation", note: "18.1° from the Sun" },
  { date: "2026-03-03", time: "5:09 PM IST", emoji: "🌕", name: "Worm Moon", note: "full moon" },
  { date: "2026-03-03", emoji: "🌘", name: "Total Lunar Eclipse", note: "" },
  { date: "2026-03-20", time: "8:15 PM IST", emoji: "🌸", name: "March Equinox", note: "" },
  { date: "2026-04-02", time: "7:43 AM IST", emoji: "🌕", name: "Pink Moon", note: "full moon" },
  { date: "2026-04-03", emoji: "✨", name: "Mercury Greatest Western Elongation", note: "27.8° from the Sun" },
  { date: "2026-04-23", emoji: "🌠", name: "Lyrids", note: "meteor shower peak (night of Apr 22–23)" },
  { date: "2026-05-01", time: "10:54 PM IST", emoji: "🌕", name: "Flower Moon", note: "full moon" },
  { date: "2026-05-07", emoji: "🌠", name: "Eta Aquarids", note: "meteor shower peak (night of May 6–7)" },
  { date: "2026-05-31", time: "2:16 PM IST", emoji: "🌕", name: "Blue Moon", note: "full moon — second full moon of May" },
  { date: "2026-06-15", emoji: "✨", name: "Mercury Greatest Eastern Elongation", note: "24.5° from the Sun" },
  { date: "2026-06-21", time: "1:55 PM IST", emoji: "☀️", name: "June Solstice", note: "longest day of the year" },
  { date: "2026-06-30", time: "5:28 AM IST", emoji: "🌕", name: "Strawberry Moon", note: "full moon" },
  { date: "2026-07-29", emoji: "🌠", name: "Delta Aquarids", note: "meteor shower peak (night of Jul 28–29)" },
  { date: "2026-07-29", time: "8:07 PM IST", emoji: "🌕", name: "Buck Moon", note: "full moon" },
  { date: "2026-08-02", emoji: "✨", name: "Mercury Greatest Western Elongation", note: "19.5° from the Sun" },
  { date: "2026-08-12", emoji: "🌑", name: "Total Solar Eclipse", note: "visible from Greenland, Iceland & Spain" },
  { date: "2026-08-13", emoji: "🌠", name: "Perseids", note: "meteor shower peak — best of the year, near new moon" },
  { date: "2026-08-15", emoji: "✨", name: "Venus Greatest Eastern Elongation", note: "45.9° from the Sun" },
  { date: "2026-08-28", time: "9:49 AM IST", emoji: "🌕", name: "Sturgeon Moon", note: "full moon" },
  { date: "2026-08-28", emoji: "🌘", name: "Partial Lunar Eclipse", note: "" },
  { date: "2026-09-23", time: "5:36 AM IST", emoji: "🌸", name: "September Equinox", note: "" },
  { date: "2026-09-25", emoji: "🪐", name: "Neptune at Opposition", note: "closest & brightest for the year" },
  { date: "2026-09-26", time: "10:20 PM IST", emoji: "🌕", name: "Harvest Moon", note: "full moon — Corn Moon" },
  { date: "2026-10-04", emoji: "🪐", name: "Saturn at Opposition", note: "closest & brightest for the year" },
  { date: "2026-10-07", emoji: "🌠", name: "Draconids", note: "meteor shower peak" },
  { date: "2026-10-12", emoji: "✨", name: "Mercury Greatest Eastern Elongation", note: "19.6° from the Sun" },
  { date: "2026-10-22", emoji: "🌠", name: "Orionids", note: "meteor shower peak (night of Oct 21–22)" },
  { date: "2026-10-26", time: "9:43 AM IST", emoji: "🌕", name: "Hunter's Moon", note: "full moon" },
  { date: "2026-11-05", emoji: "🌠", name: "Taurids", note: "meteor shower peak (night of Nov 4–5)" },
  { date: "2026-11-18", emoji: "🌠", name: "Leonids", note: "meteor shower peak (night of Nov 17–18)" },
  { date: "2026-11-20", emoji: "✨", name: "Mercury Greatest Western Elongation", note: "19.6° from the Sun" },
  { date: "2026-11-24", time: "8:25 PM IST", emoji: "🌕", name: "Beaver Moon", note: "full moon — supermoon" },
  { date: "2026-11-25", emoji: "🪐", name: "Uranus at Opposition", note: "closest & brightest for the year" },
  { date: "2026-12-14", emoji: "🌠", name: "Geminids", note: "meteor shower peak — strongest of the year" },
  { date: "2026-12-22", time: "2:19 AM IST", emoji: "❄️", name: "December Solstice", note: "shortest day of the year" },
  { date: "2026-12-22", emoji: "🌠", name: "Ursids", note: "meteor shower peak (night of Dec 21–22)" },
  { date: "2026-12-23", time: "7:00 AM IST", emoji: "🌕", name: "Cold Moon", note: "full moon — supermoon" },
];

const formatEventDate = (iso) => {
  const d = new Date(iso + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

const daysUntil = (iso) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(iso + "T00:00:00");
  return Math.round((d - today) / 86400000);
};

const UpcomingEvents = () => {
  const upcoming = astronomyEvents
    .filter((e) => daysUntil(e.date) >= 0)
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <div className="events-table">
      {upcoming.length === 0 ? (
        <p className="events-empty">No upcoming events in the list right now — check back soon.</p>
      ) : (
        upcoming.map((e) => (
          <div className="event-row" key={e.name + e.date + (e.time || "")}>
            <span className="event-emoji">{e.emoji}</span>
            <div className="event-info">
              <span className="event-name">{e.name}</span>
              {e.note && <span className="event-note">{e.note}</span>}
            </div>
            <div className="event-when">
              <span className="event-date">
                {formatEventDate(e.date)}
                {e.time && ` · ${e.time}`}
              </span>
              <span className="event-countdown">
                {daysUntil(e.date) === 0 ? "today" : `in ${daysUntil(e.date)} days`}
              </span>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

const GratefulMoments = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="grateful-moments">
      <button
        type="button"
        className="grateful-moments-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        🌌 few moments I'm grateful for {open ? "▲" : "▼"}
      </button>

      {open && (
        <ul className="grateful-moments-list">
          <li>The very first object I ever saw through my telescope was Jupiter — along with its 4 biggest moons.</li>
          <li>
            I've spotted the Andromeda Galaxy twice. The first time, it sat directly overhead, so I lay on
            my terrace and spent about 1.5 hours manually tracking it down — and cried happy tears when it
            finally came into view.
          </li>
        </ul>
      )}
    </div>
  );
};

const Astronomy = () => {
  return (
    <div className="text-color-dark astronomy-page">
      <AstronomyNightSky />
      <div className="align-items-center-in-div">
        <div className="astronomy-intro-row">
          <img
            src={stargazing_photo}
            alt="Kuhuk stargazing with her telescope"
            className="astronomy-photo"
          />

          <div className="astronomy-story-text">
            <h2 className="section-title astronomy-story-title">always looking up 🌌</h2>

            <p className="astronomy-intro">
              Since I was a little girl, I have always been curious. Questioning everything.
              And this curiosity has turned me into an Astrophile. I like to read astronomy
              books and watch sci-fi movies and stargaze of course. In 2020 I bought my very
              first telescope 🔭 from Celestron and since then I started doing astrophotography.
              I also communicate science mainly in the field of Astronomy and space sciences,
              both online and offline.
              <br /><br />
              If you're looking for a go-to astronomy buddy, I can be one! 🙂 Here is my
              Instagram page for all the Astro stuff — do check this out and DM me ✨
            </p>

            <a
              href="https://www.instagram.com/astro_kuhuk/"
              target="_blank"
              rel="noreferrer"
              className="pill-button pill-button-primary astronomy-instagram-link"
            >
              @astro_kuhuk →
            </a>

            <GratefulMoments />
          </div>
        </div>

        <h2 className="section-title astronomy-events-title">upcoming events 🌠</h2>
        <p className="section-subtitle">sorted by what's next — dates from seasky.org, times converted to IST</p>
        <UpcomingEvents />

        {/* EBOOK CTA */}
        <div className="ebook-card">
          <h3>📘 Space, Simplified</h3>
          <p>Beginner-friendly astronomy ebook</p>

          <button
            className="pill-button pill-button-primary"
            onClick={() =>
              window.open(
                "https://astrokuhuk.myinstamojo.com/product/wonders-of-astronomy/",
                "_blank"
              )
            }
          >
            Download Ebook
          </button>
        </div>
      </div>
    </div>
  );
};

export default Astronomy;
